import { Box, Typography } from "@mui/material";

type FindingTypeCellProps = {
  value: string | null | undefined;
};

const TYPE_LABELS: Record<string, string> = {
  CveFinding: "Vulnerability",
  AdvisoryFinding: "Advisory",
  CheckFinding: "Check",
  GenericFinding: "Finding",
};

export function FindingTypeCell({ value }: FindingTypeCellProps) {
  const label = value ? TYPE_LABELS[value] || "Unknown" : "-";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          fontSize: "14px",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
